import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/specialisms.json";

export const useSectors = ({ locale, limit } = {}) => {
  const collection = useSourceFlowCollection(data).filter(function(item) {
    return item.region?.includes(locale == "/us/" ? "United States" : "United Kingdom");
  });

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useSectors;
